export const Button = ({ title }) => {
  return (
    <div className="uppercase font-medium text-white text-sm  py-3.5 px-8.5 md:py-4.5 md:px-10   bg-darkBlue hover:bg-primaryBlue cursor-pointer font-halyard tracking-0.5px leading-5 ">
      {title}
    </div>
  );
};
